/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LatLong
 */
export interface LatLong {
    /**
     * Latitude
     * @type {number}
     * @memberof LatLong
     */
    latitude: number;
    /**
     * Longitude
     * @type {number}
     * @memberof LatLong
     */
    longitude: number;
}

export function LatLongFromJSON(json: any): LatLong {
    return LatLongFromJSONTyped(json, false);
}

export function LatLongFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatLong {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function LatLongToJSON(value?: LatLong | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}


